import React from "react";
import { Tooltip, TooltipTrigger, TooltipContent } from "@jem-open/jem-ui";
import { formatTimeShort } from "../utils/attendanceUtils";

interface TimelineMarkerProps {
  type: "clock-in" | "clock-out";
  time: string;
  position: number;
  late?: boolean;
}

const TimelineMarker: React.FC<TimelineMarkerProps> = ({
  type,
  time,
  position,
  late = false,
}) => {
  const getColor = (): string => {
    if (type === "clock-out") return "#9CA3AF";
    return late ? "#FFA500" : "#062133";
  };

  const formatted = formatTimeShort(time) || time;
  const label =
    type === "clock-in" ? `Clock in: ${formatted}` : `Clock out: ${formatted}`;

  return (
    <div
      style={{
        position: "absolute",
        top: "50%",
        left: `${position}%`,
        transform: "translate(-50%, -50%)",
        zIndex: 2,
        width: 12,
        height: 12,
      }}
    >
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            style={{
              width: 12,
              height: 12,
              borderRadius: "50%",
              border: "2px solid white",
              boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
              backgroundColor: getColor(),
              cursor: "pointer",
              padding: 0,
              outlineOffset: 2,
            }}
          />
        </TooltipTrigger>
        <TooltipContent sideOffset={4}>{label}</TooltipContent>
      </Tooltip>
    </div>
  );
};

export default TimelineMarker;
